import { Component, OnInit } from '@angular/core';
import { Grid } from '../../../core/components/grid/grid.model';
import { GridOptions } from '../../../core/components/grid/grid.types';

@Component({
  selector: 'tt-furniture-fabrics-suppliers',
  templateUrl: './furniture-fabrics-suppliers.component.html',
  styleUrls: ['./furniture-fabrics-suppliers.component.css']
})
export class FurnitureFabricsSuppliersComponent implements OnInit {
    public grid?: GridOptions;

    private loadGrid() {
        if (!this.grid) {
            this.grid = new Grid()
                .setRememberId('furniturefabricssuppliers_grid')
                .setLoadDataFunction({
                    method: 2902,
                    parameters: {}
                })
                .setKendoConfig({ height: '100%' })
                .setToolbar({ wrapping: true });
        } else {
            this.grid?.gridfunc?.read();
        }
    }

    private async init() {
        this.loadGrid();
    }

    ngOnInit() {
        this.init();
    }
}
